import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import useInitialize from "./useInitialize";
import useStore from "./useStore";
import { CreateActionContext } from "./CreateActionContext";
import DeliveryNoteForm from "../../components/DeliveryNoteForm";

function useCreateAction(index: any, formDefaultValues: any = {}, formWidgets: any = {}, deliveryNoteConfiguration: any = {}, showReceiverAccountSelector = false): any {
  const initialize = useInitialize();
  const initializeFunction = () => initialize(formDefaultValues);

  const onSuccessStore = () => {
    setShowModal(false);
    index();
  };

  const store = useStore();
  const storeFunction = () => store(onSuccessStore);

  const contextInstance = useContext(CreateActionContext);
  const { setShowModal } = contextInstance;
  const { element } = contextInstance;

  const formRef = createRef<JSONSchemaForm>();

  const modalConfig = {
    title: "create_delivery_note",
    contextInstance: contextInstance,
    onSubmit: () => formRef.current?.formElement.current.requestSubmit(),
    size: "modal-xl",
    fullscreen: true as true,
  };

  const formConfig = {
    formRef: formRef,
    onSubmit: () => {
      storeFunction();
    },
    element: element,
    context: CreateActionContext,
    className: "delivery-note-form",
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <DeliveryNoteForm formConfig={formConfig} formWidgets={formWidgets} deliveryNoteConfiguration={deliveryNoteConfiguration} showReceiverAccountSelector={showReceiverAccountSelector}/>
    </CrudModuleFactoryModal>
  );

  return {
    initializeFunction,
    actionTemplate,
  };
}

export default useCreateAction;
